import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'

import BillingAddCreditCardForm from './BillingAddCreditCardForm'
import { updateCreditCard } from 'features/Billing/Billing.actions'

const formName = 'addCreditCard'

const stateToProps = (state, { ban }) => {
  const selector = formValueSelector(formName)
  const isConfirmed = selector(state, 'confirm')

  const {
    billing: { updateLoading },
  } = state

  return {
    form: formName,
    initialValues: {
      ban,
    },
    loading: updateLoading,
    isConfirmed,
  }
}

const dispatchToProps = {
  updateCreditCard,
}

export default connect(stateToProps, dispatchToProps)(reduxForm({})(BillingAddCreditCardForm))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddCreditCardForm/BillingAddCreditCardForm.container.js